import { Pays } from '../global/pays';
import { PostalCodeByCountry } from '../global/postal-code-by-country';
import { Rue } from '../global/rue';
import { Langue } from '../global/langue';

export class Adresse {
  public id: number;
  public structure_Localite: PostalCodeByCountry;
  public structure_Rue: Rue;
  public structure_RueNumero?: string;
  public structure_RueBoite?: string;
  public langue: Langue;
  public impression_Adresse?: string;
  public impression_CodePostal?: string;
  public impression_Localite?: string;
  public impression_Pays?: string;
  public telephone?: string;
  public fax?: string;
  public gsm?: string;
  public site?: string;
  public mail?: string;
}

export class AddressForFormArray {
  type: string;
  structure_RueId: Rue;
  structure_RueNumero: string;
  structure_RueBoite: string;
  structure_LocaliteId: PostalCodeByCountry;
  impression_Pays: string;
  impression_CodePostal: string;
  impression_Localite: string;
  impression_Adresse: string;
  pays: Pays | number;
  gsm: string;
  mail: string;
  telephone: string;
  fax: string;
  site: string;
  toRemove: boolean;
  id?: number;
}
export class AddressAsAList {
  type: string;
  description: string;
  contactID: number;
  adresse: {
    toRemove?: boolean;
    structure_LocaliteId: number;
    structure_RueId: number;
    structure_RueNumero: string;
    structure_RueBoite: string;
    langueId: number;
    impression_Adresse: string;
    impression_CodePostal: string;
    impression_Localite: string;
    impression_Pays: string;
    telephone: string;
    fax: string;
    gsm: string;
    site: string;
    mail: string;
    id: number;
  };
}
